export * from './redirect.component';



// WEBPACK FOOTER //
// ./src/components/app/redirect/index.ts